import { some, trim } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import TextField from './TextField';
import { MAX_NAME_LENGTH } from './const/lengths';
import useT from '../../../utils/Translations/useT';
import useHelpNote from '../../../utils/Translations/useHelpNote';
const EntityNameField = ({ validate, required = true, name = 'name', label, tooltipTitle, excludeNames, maxLength = MAX_NAME_LENGTH, ...props }) => {
    const t = useT();
    const getHelpNoteTooltipTitle = useHelpNote();
    const _label = useMemo(() => label || t('Name'), [t, label]);
    const resolvedTooltipTitle = useMemo(() => tooltipTitle || getHelpNoteTooltipTitle(label || 'Name'), [getHelpNoteTooltipTitle, label, tooltipTitle]);
    const _validate = useCallback((value) => {
        const validationResult = validate && validate(value);
        if (validationResult) {
            return validationResult;
        }
        const _value = trim(value).toLowerCase();
        return excludeNames &&
            some(excludeNames, n => trim(n).toLowerCase() === _value)
            ? 'Name should be unique'
            : '';
    }, [validate, excludeNames]);
    return (<TextField validate={_validate} {...props} label={_label} maxLength={maxLength} name={name} required={required} tooltipTitle={resolvedTooltipTitle}/>);
};
export default EntityNameField;
